import moment from 'moment';
import helpers from 'src/helpers';

export const FIELDS = {
  // Fields Without Grouping
  type: 'Contact Type',
  companyContactId: 'Company Contact ID',
  // Name fields
  firstName: 'First Name',
  lastName: 'Last Name',
  //  Phone Fields
  phone1: 'Phone #1',
  phone2: 'Phone #2',
  email: 'Email Address',
  doNotText: 'Do Not Text',
  //  Birthday Fields
  birthday: 'Birthday (MM/DD/YYYY)',
  birthdayMonth: 'Month',
  birthdayDay: 'Day',
  birthdayYear: 'Year',
  //  Address Fields
  address1: 'Address Line 1',
  address2: 'Address Line 2',
  city: 'City',
  region: 'State/Province',
  postalCode: 'Postal Code',
  //  Less Common Fields
  tags: 'Categories/Tags',
  companyName: 'Company',
  //  Team Information Fields
  consultantId: 'Consultant ID',
  uplineFirstName: 'Upline First Name',
  uplineLastName: 'Upline Last Name',
  uplineConsultantId: 'Upline ID',
  joinedTeamDateTime: 'Joined Team Date',
  // hostFirstName: 'Host First Name Originally Purchased From',
  // hostLastName: 'Host Last Name Originally Purchased From',
  // firstOrderDate: 'First Order Date',
  // lastOrderDate: 'Last Order Date',
  notes: 'Notes',
};

export const STEPS = {
  upload: {
    key: 0,
    label: 'Upload CSV file'
  },
  setup: {
    key: 1,
    label: 'Setup fields mapping'
  },
  results: {
    key: 2,
    label: 'Import results'
  },
};

export const STEPS_V2 = {
  upload: {
    key: 0,
    label: 'Upload CSV'
  },
  mapFields: {
    key: 1,
    label: 'Map Fields'
  },
  groupEvent: {
    key: 2,
    label: 'Group / Event'
  },
  results: {
    key: 3,
    label: 'Results'
  },
};

// CON-1608 — column headers for EVERY surface that shows a CP-field to
// CSV-column mapping (the mapping rows, the counter-pill popovers, and the
// import-template preview tables). Deliberately identical wording in all
// three so the direction is learned once: the CP field on the left is
// FILLED FROM the spreadsheet column on the right.
export const MAPPING_DIRECTION_LABELS = {
  cpField: 'CP Field',
  csvColumn: 'Your Spreadsheet Column',
};

export const CONTACT_COLUMN_LABELS = {
  firstName: 'First Name',
  lastName: 'Last Name',
  phone1: 'Phone 1',
  phone2: 'Phone 2',
  phone3: 'Phone 3',
  email: 'Email',
};

export const CONTACT_DISPLAY_CONFIG = [
  {
    label: 'Name',
    keys: ['firstName', 'lastName'],
    // formatter: (parts) => parts.filter(Boolean).join(' ')
    formatter: (parts) => helpers.transform.toFullName(...parts)
  },
  {
    label: 'Phone 1',
    key: 'phone1',
    formatter: (value) => (value ? helpers.transform.toPhoneNumber(value) : '')
  },
  {
    label: 'Phone 2',
    key: 'phone2',
    formatter: (value) => (value ? helpers.transform.toPhoneNumber(value) : '')
  },
  {
    label: 'Phone 3',
    key: 'phone3',
    formatter: (value) => (value ? helpers.transform.toPhoneNumber(value) : '')
  },
  {
    label: 'Email',
    key: 'email',
    formatter: (value) => value || ''
  },
  {
    label: 'Customer?',
    key: 'isACustomer',
    formatter: (value) => (value ? 'Yes' : 'No')
  },
  {
    label: 'Contact Type',
    key: 'type',
    formatter: (value) => value || ''
  },
  {
    label: 'Do Not Text?',
    key: 'doNotText',
    formatter: (value) => (value ? 'Do NOT Text' : 'CAN Text')
  },
  {
    label: 'Categories/Tags',
    key: 'contactCategoryNames',
    formatter: (value) => (Array.isArray(value) ? value.join(', ') : (value || ''))
  },
  {
    label: 'Birthday',
    keys: ['bdayMonth', 'bdayDay', 'bdayYear'],
    formatter: (parts) => helpers.transform.formatBirthdayMDYSeparateFieldsWithDashes(...parts)
  },
  {
    label: 'Notes',
    key: 'notes',
    formatter: (value) => value || ''
  },
  {
    label: 'Company',
    key: 'companyName',
    formatter: (value) => value || ''
  },
  {
    label: 'Contact Address 1',
    key: 'contactAddress1',
    formatter: (value) => value || ''
  },
  {
    label: 'Contact Address 2',
    key: 'contactAddress2',
    formatter: (value) => value || ''
  },
  {
    label: 'Contact City',
    key: 'contactCity',
    formatter: (value) => value || ''
  },
  {
    label: 'Contact State/Province',
    key: 'contactRegionName',
    formatter: (value) => value || ''
  },
  {
    label: 'Contact Postal',
    key: 'contactPostalCode',
    formatter: (value) => value || ''
  },
  {
    label: 'Contact Country',
    key: 'contactCountryName',
    formatter: (value) => value || ''
  },
  {
    label: 'Shipping Address 1',
    key: 'shippingAddress1',
    formatter: (value) => value || ''
  },
  {
    label: 'Shipping Address 2',
    key: 'shippingAddress2',
    formatter: (value) => value || ''
  },
  {
    label: 'Shipping City',
    key: 'shippingCity',
    formatter: (value) => value || ''
  },
  {
    label: 'Shipping State/Province',
    key: 'shippingRegionName',
    formatter: (value) => value || ''
  },
  {
    label: 'Shipping Postal',
    key: 'shippingPostalCode',
    formatter: (value) => value || ''
  },
  {
    label: 'Shipping Country',
    key: 'shippingCountryName',
    formatter: (value) => value || ''
  },
  {
    label: 'Company Contact IDs',
    key: 'companyContactIds',
    formatter: (value) => (Array.isArray(value) ? value.join(', ') : (value || ''))
  },
  {
    label: 'Consultant ID',
    key: 'consultantId',
    formatter: (value) => value || ''
  },
  {
    label: 'Upline First Name',
    key: 'uplineFirstName',
    formatter: (value) => value || ''
  },
  {
    label: 'Upline Last Name',
    key: 'uplineLastName',
    formatter: (value) => value || ''
  },
  {
    label: 'Upline ID',
    key: 'uplineConsultantId',
    formatter: (value) => value || ''
  },
  {
    label: 'Joined Team Date',
    key: 'joinedTeamDateTime',
    // Stored at noon UTC by the importer so the calendar date is stable in
    // every timezone the product renders in.
    formatter: (value) => (value ? moment(value).format('MM/DD/YYYY') : '')
  },
];
